import i18n from '@/locales/i18n'
import { PRODUCTION_LINE_ROUTES } from '@/router/routes'
import type { RouteType } from '@rfc/rfc-components-library/types'
import AdminProductionLinesEditView from '../../views/AdminView/AdminProductionLinesView/AdminProductionLinesEditView.vue'
import AdminProductionLinesView from '../../views/AdminView/AdminProductionLinesView/AdminProductionLinesView.vue'

export const PRODUCTION_LINES_LIST_ROUTE_NAME = 'productsLineList'
export const PRODUCTION_LINES_DETAIL_ROUTE_NAME = 'productsLineDetail'

const routes: RouteType[] = [
    {
        path: PRODUCTION_LINE_ROUTES.baseUrl,
        name: PRODUCTION_LINES_LIST_ROUTE_NAME,
        component: AdminProductionLinesView,
        meta: {
            title: i18n.global.t('menu.productionLines'),
            authRequired: true
        }
    },
    {
        path: PRODUCTION_LINE_ROUTES.detailUrl,
        name: PRODUCTION_LINES_DETAIL_ROUTE_NAME,
        component: AdminProductionLinesEditView,
        meta: {
            title: i18n.global.t('menu.productionLines'),
            authRequired: true
        }
    }
]

export default routes
